import { useQuery } from '@tanstack/react-query';

import { getUseRegulatorQueryOptions } from './options';

export default function useRegulator(code: string) {
    const options = getUseRegulatorQueryOptions(code);
    return useQuery(options);
}
